// TODO 改进
import LogisticsCompany from "@/enum/LogisticsCompany";
/**
 * 获取快递单中数字部分（去除以字母和0开头的部分）的起始位置
 * @param {String} waybillNo
 * @return {Number}
 * @private
 */
function getNumberPartStartIndex(waybillNo: any) {
    for (let i = 0; i < waybillNo.length; i++) {
        const charCode = waybillNo.charCodeAt(i);
        if (charCode > 48 && charCode < 58) {
            // in 1..9
            return i;
        }
    }
    return -1;
}
function getLastNo(aNumber: any) {
    return (aNumber % 10).toString();
}
/**
 * 运单号生成器,用于联想录入运单号
 */
class WaybillNoGenerator {
    copies: any;
    currentWaybillNo: any;
    logisticsCompany: any;
    step: any;
    /**
     * @param logisticsCompany 物流公司代码
     * @param firstWaybillNo 第一个运单号
     * @param copies 打印份数
     * @param step 递增数,如果type为EMS或SF不需要该参数
     */
    constructor(logisticsCompany: LogisticsCompany, firstWaybillNo: any, copies: any, step: any) {
        this.logisticsCompany = logisticsCompany;
        this.currentWaybillNo = firstWaybillNo;
        this.copies = copies;
        this.step = step;
    }
    /**
     * 获取下一个运单号
     * @returns {String}
     */
    next() {
        const logisticsCompanyCode = this.logisticsCompany;
        if (logisticsCompanyCode === "SF") {
            // 顺丰
            return this._nextSf();
        }
        if (logisticsCompanyCode === "EMS" || logisticsCompanyCode === "EYB") {
            // EMS
            return this._nextEms();
        }
        return this._increment(); // 递增
    }
    _increment() {
        const currentWaybillNo = this.currentWaybillNo;
        const numberPartStartIndex = getNumberPartStartIndex(currentWaybillNo);
        let prefix;
        let numberPart;
        if (numberPartStartIndex === 0) {
            // 整个都是数字
            numberPart = parseInt(currentWaybillNo, 10);
        } else if (numberPartStartIndex > 0) {
            prefix = currentWaybillNo.substring(0, numberPartStartIndex);
            numberPart = parseInt(currentWaybillNo.substring(numberPartStartIndex), 10);
        } else {
            // -1
            throw Error("快递单号不正确，必须以数字结尾");
        }
        numberPart += this.step * this.copies;
        const nextWaybillNo = prefix ? prefix + numberPart : String(numberPart);
        this.currentWaybillNo = nextWaybillNo;
        return nextWaybillNo;
    }
    /**
     * 计算ems快递单号
     * ems快递单号格式：10 61945842 ? 08
     * 1、前两位：10标准快递，50经济快递
     * 2、中间：自增1
     * 3、?号部分：通过以下公式计算
     *      a.X=第一位数字*8+第二位数字*6+第三位数字*4+第四位数字*2+第五位数字*3+第六位数字*5+第七位数字*9+第八位数字*7
     *      b.Y=X/11得出的余数
     *      c.Z = 11 - Y
     *      当Z=10时，最后一位数字是0，当Z=11时，最后一位数字是5，当Z<10时，最后一位数字是Z
     * 4、后两位：08意义未知
     */
    _nextEms() {
        for (let counter = 0; counter < this.copies; counter++) {
            const currentWaybillNo = this.currentWaybillNo;
            const multi = [8, 6, 4, 2, 3, 5, 9, 7];
            const p1 = currentWaybillNo.substring(0, 2);
            let p2 = (parseInt(currentWaybillNo.substring(2, 10), 10) + 1).toString();
            const p4 = currentWaybillNo.substring(11);
            // 如果p2以0开通的话在parseInt的时候前面的0会被去掉，补回前面的0，确保p2的长度为8位
            if (p2.length < 8) {
                for (let j = 0; j < 8 - p2.length; j++) {
                    p2 = `0${p2}`;
                }
            }
            // X=第一位数字*8+第二位数字*6+第三位数字*4+第四位数字*2+第五位数字*3+第六位数字*5+第七位数字*9+第八位数字*7
            let X = 0;
            for (let i = 0, len = p2.length; i < len; i++) {
                const c = p2.charAt(i);
                X += parseInt(c.toString(), 10) * multi[i];
            }
            // 计算X/11得出的余数=Y
            const Y = X % 11;
            // 计算Z=11-Y 当Z=10时，最后一位数字是0 当Z=11时，最后一位数字是5 当Z<10时，最后一位数字是Z
            const Z = 11 - Y;
            let nextWaybillNo = "";
            if (Z === 10) {
                nextWaybillNo = `${p1 + p2}0${p4}`;
            } else if (Z === 11) {
                nextWaybillNo = `${p1 + p2}5${p4}`;
            } else if (Z < 10) {
                nextWaybillNo = p1 + p2 + Z + p4;
            }
            this.currentWaybillNo = nextWaybillNo;
        }
        return this.currentWaybillNo;
    }
    _nextSf() {
        for (let counter = 0; counter < this.copies; counter++) {
            const currentWaybillNo = this.currentWaybillNo;
            const p1 = currentWaybillNo.substring(0, 11);
            const c4 = parseInt(currentWaybillNo.charAt(3), 10);
            const c5 = parseInt(currentWaybillNo.charAt(4), 10);
            const c6 = parseInt(currentWaybillNo.charAt(5), 10);
            const c7 = parseInt(currentWaybillNo.charAt(6), 10);
            const c8 = parseInt(currentWaybillNo.charAt(7), 10);
            const c9 = parseInt(currentWaybillNo.charAt(8), 10);
            const c10 = parseInt(currentWaybillNo.charAt(9), 10);
            const c11 = parseInt(currentWaybillNo.charAt(10), 10);
            const c12 = parseInt(currentWaybillNo.charAt(11), 10);
            let nextWaybillNo = (Number(p1) + 1).toString();
            // 当第11位数字、第10位数字、第9位数字、第8位数字、第7位数字、第6位数字、第5位数字都等于9时，根据第4位数字判断
            if (c11 === 9 && c10 === 9 && c9 === 9 && c8 === 9 && c7 === 9 && c6 === 9 && c5 === 9) {
                // 当第4位数字=0，2，4，6，8时，，第二张运单的最后一位数字=上一张运单最后一位数字+5，取结果的个位数
                if (c4 === 0 || c4 === 2 || c4 === 4 || c4 === 6 || c4 === 8) {
                    nextWaybillNo += getLastNo(c12 + 5);
                }
                // 当第4位数字=1，3，5，7时，第二张运单的最后一位数字=上一张运单最后一位数字+4,取结果的个位数
                else if (c4 === 1 || c4 === 3 || c4 === 5 || c4 === 7) {
                    nextWaybillNo += getLastNo(c12 + 4);
                }
            }
            // 当第11位数字、第10位数字、第9位数字、第8位数字、第7位数字、第6位数字都等于9时，根据第5位数字判断
            else if (c11 === 9 && c10 === 9 && c9 === 9 && c8 === 9 && c7 === 9 && c6 === 9) {
                // 当第5位数字=0，1，2，4，5，7，8时，第二张运单的最后一位数字=上一张运单最后一位数字+9，取结果的个位数
                if (c5 === 0 || c5 === 1 || c5 === 2 || c5 === 4 || c5 === 5 || c5 === 7 || c5 === 8) {
                    nextWaybillNo += getLastNo(c12 + 9);
                }
                // 当第5位数字=3，6时，第二张运单的最后一位数字=上一张运单最后一位数字+8，取结果的个位数
                else if (c5 === 3 || c5 === 6) {
                    nextWaybillNo += getLastNo(c12 + 8);
                }
            }
            // 当第11位数字、第10位数字、第9位数字、第8位数字、第7位数字都等于9时，看第6位数字的规律
            else if (c11 === 9 && c10 === 9 && c9 === 9 && c8 === 9 && c7 === 9) {
                // 当第6位数字=0，1，2，3，4，5，6，7，8时，第二张运单的最后一位数字=上一张运单最后一位数字+3，取结果的个位数
                if (
                    c6 === 0 ||
                    c6 === 1 ||
                    c6 === 2 ||
                    c6 === 3 ||
                    c6 === 4 ||
                    c6 === 5 ||
                    c6 === 6 ||
                    c6 === 7 ||
                    c6 === 8
                ) {
                    nextWaybillNo += getLastNo(c12 + 3);
                }
            }
            // 当第11位数字、第10位数字、第9位数字、第8位数字都等于9时，看第7位数字的规律
            else if (c11 === 9 && c10 === 9 && c9 === 9 && c8 === 9) {
                // 当第7位数字=1，2，3，4，5，6，7，8时，第二张运单的最后一位数字=上一张运单最后一位数字+6，取结果的个位数
                if (c7 === 1 || c7 === 2 || c7 === 3 || c7 === 4 || c7 === 5 || c7 === 6 || c7 === 7 || c7 === 8) {
                    nextWaybillNo += getLastNo(c12 + 6);
                }
                // 当第7位数字=0时，第二张运单的最后一位数字=上一张运单最后一位数字+7，取结果的个位数
                else if (c7 === 0) {
                    nextWaybillNo += getLastNo(c12 + 7);
                }
            }
            // 当第11位数字、第10位数字、第9位数字都等于9时，看第8位数字的规律
            else if (c11 === 9 && c10 === 9 && c9 === 9) {
                // 当第8位数字=0，3，6时，第二张运单的最后一位数字=上一张运单最后一位数字+0，取结果的个位数
                if (c8 === 0 || c8 === 3 || c8 === 6) {
                    nextWaybillNo += getLastNo(c12);
                }
                // 当第8位数字=1，2，4，5，7，8时，第二张运单的最后一位数字=上一张运单最后一位数字+9，取结果的个位数
                else if (c8 === 1 || c8 === 2 || c8 === 4 || c8 === 5 || c8 === 7 || c8 === 8) {
                    nextWaybillNo += getLastNo(c12 + 9);
                }
            }
            // 当第11位数字、第10位数字都等于9时，看第9位数字的规律
            else if (c11 === 9 && c10 === 9) {
                // 当第9位数字=0，2，4，6，8时，第二张运单最后一位数字=上一张运单最后一位数字+3，取结果的个位数
                if (c9 === 0 || c9 === 2 || c9 === 4 || c9 === 6 || c9 === 8) {
                    nextWaybillNo += getLastNo(c12 + 3);
                }
                // 当第9位数字=1，3，5，7时，第二张运单最后一位数字=上一张运单最后一位数字+2，取结果的个位数
                else if (c9 === 1 || c9 === 3 || c9 === 5 || c9 === 7) {
                    nextWaybillNo += getLastNo(c12 + 2);
                }
            }
            // 当第11位数字=9时，看第10位数字的规律
            else if (c11 === 9) {
                // 当第10位数字=0，1，2，4，5，7，8时，第二张运单的最后一位数字=上一张运单最后一位数字+6，取结果的个位数
                if (c10 === 0 || c10 === 1 || c10 === 2 || c10 === 4 || c10 === 5 || c10 === 7 || c10 === 8) {
                    nextWaybillNo += getLastNo(c12 + 6);
                }
                // 当第10位数字=3，6时，第二张运单的最后一位数字=上一张运单最后一位数字+5，取结果的个位数
                else if (c10 === 3 || c10 === 6) {
                    nextWaybillNo += getLastNo(c12 + 5);
                }
            }
            // 当第11位数不等于9时，第二张运单的最后一位数字=上一张运单最后一位数字+9，取结果的个位数
            else if (c11 !== 9) {
                nextWaybillNo += getLastNo(c12 + 9);
            } else {
                nextWaybillNo = "";
            }
            this.currentWaybillNo = nextWaybillNo;
        }
        return this.currentWaybillNo;
    }
}
export default WaybillNoGenerator;
